import {
  ReviewSubjectType,
  type ReviewThreadListItemModel,
} from "@/api/cle-api";

export interface ReviewThreadDetailLocationState {
  thread?: ReviewThreadListItemModel;
}

export const isReviewSubjectType = (
  value: string,
): value is ReviewSubjectType =>
  Object.values(ReviewSubjectType).includes(value as ReviewSubjectType);

export const getReviewThreadDetailPath = (
  thread: Pick<
    ReviewThreadListItemModel,
    "subjectType" | "ownerUserId" | "subjectId"
  >,
): string =>
  `/efteruddannelse/${thread.subjectType}/${thread.ownerUserId}/${thread.subjectId}`;
